// general bot api's
const baseApiURL = process.env.REACT_APP_API_URL;
const cloudFlareInitialConfigURL = process.env.REACT_APP_API_URL_CLOUDFLARE_R2;

const healthyCheckApi = "/hc";
const getCategoriaApi = "/api/categoria";
const saveLeadApi = "/api/lead";
const plansApi = "/api/plano";
const cepApi = "/api/endereco";
const getPropostaApi = "/api/v2/proposta";
const pagamentoCartaoApi = "/api/pagamento/cartao";
const pagamentoBoletoApi = "/api/pagamento/boleto";
const pagamentoPixApi = "/api/pagamento/pix";
const planDetailsApi = "/api/plano/detalhes";
const forbiddenWords = "/api/lead/validar-palavras";
const catalogApi = "/api/v1/catalogo";
const validateCouponApi = "/api/v1/cupom/validar";
const initialConfigApi = "/fluxo-bot-react/config-fluxo-bot-react.json"; //from cloudflare
const getRangesApi = "/api/v1/catalogo/valor-range";
const selectedPlan = "/api/Plano/selecionado";
const conversacoesApi = "/api/v1/conversacoes";

// seguros api's
const insuranceApiURL = process.env.REACT_APP_INSURANCE_API_URL;

const insuranceValueApi = "/seguros/v1/prestamista";
const insuranceContractApi = "/seguros/v1/contratos";

export {
  baseApiURL,
  cloudFlareInitialConfigURL,
  healthyCheckApi,
  getCategoriaApi,
  saveLeadApi,
  plansApi,
  cepApi,
  getPropostaApi,
  pagamentoCartaoApi,
  pagamentoBoletoApi,
  pagamentoPixApi,
  planDetailsApi,
  forbiddenWords,
  catalogApi,
  validateCouponApi,
  initialConfigApi,
  selectedPlan,
  insuranceApiURL,
  insuranceValueApi,
  insuranceContractApi,
  getRangesApi,
  conversacoesApi,
};
